        <div class="footer centered">
            <span class="appName"> CLHUB App</span>  - -  <span><em class="ver">vers.{{ver}}</em></span>
        </div>